import { render } from "./RebateIncome.vue?vue&type=template&id=68e5a3c8&scoped=true"
import script from "./RebateIncome.vue?vue&type=script&lang=js"
export * from "./RebateIncome.vue?vue&type=script&lang=js"

import "./RebateIncome.vue?vue&type=style&index=0&id=68e5a3c8&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e5a3c8"]])

export default __exports__